import type { UserRole } from '../hooks/useUserRole';

export type FeatureKey = 'transactions' | 'budgets' | 'assistant_ia' | 'ocr_scan';

export interface FeatureDefinition {
  key: FeatureKey;
  label: string;
  description: string;
}

export const ADMIN_FEATURES: FeatureDefinition[] = [
  {
    key: 'transactions',
    label: 'Transactions',
    description: 'Saisie et consultation des transactions',
  },
  {
    key: 'budgets',
    label: 'Budgets',
    description: 'Gestion et suivi des budgets',
  },
  {
    key: 'assistant_ia',
    label: 'Assistant IA',
    description: 'Chat conseiller financier',
  },
  {
    key: 'ocr_scan',
    label: 'Scan ticket (OCR)',
    description: 'Analyse de tickets de caisse (mobile)',
  },
];

export interface UserFeatureState {
  feature_key: FeatureKey;
  enabled: boolean;
  is_override: boolean;
  role_default: boolean;
}

export function defaultFeatureEnabled(role: UserRole, featureKey: FeatureKey): boolean {
  if (role === 'admin' || role === 'premium') return true;
  if (featureKey === 'ocr_scan') return false;
  return true;
}

export function featureLabel(key: FeatureKey): string {
  return ADMIN_FEATURES.find((f) => f.key === key)?.label ?? key;
}
